import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Editor from "@tinymce/tinymce-vue";
import ApiService from "@/_services/api.service"
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomWysiwyg',
  props: {
  context: Object,
  content: {
    type: String,
    required: true,
    default: "",
  },
  images: {
    type: Array,
    required: true,
    default: () => [],
  },
  height: {
    type: Number,
    default: 300,
  },
  wysiwygClass: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;



const tinyMceApiKey = process.env.VUE_APP_TINY_MCE_API_KEY;
const images = ref(props.images);
let wysiwyg = ref(props.content ? props.content:  props?.context?.attrs?.content);

function handleInput(e) {
  props.context.node.input(wysiwyg.value)
}

const wysiwyg_image_upload_handler = (blobInfo, success, failure, progress) =>
  new Promise((resolve, reject) => {
    const file = new FormData();
    file.append("file", blobInfo.blob(), blobInfo.filename());
    file.append("context", "product_description");

    ApiService.post("images", file)
      .then((response) => {
        success(response.data.data.url);
        images.value.push(response.data.data);
      })
      .catch((error) => {
        failure({ message: "Une erreur est survenu", remove: true });
      });
  });

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.wysiwygClass)
  }, [
    _createVNode(_unref(Editor), {
      "api-key": _unref(tinyMceApiKey),
      "model-events": "change",
      initialValue: __props.content,
      onChange: handleInput,
      modelValue: _unref(wysiwyg),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(wysiwyg) ? (wysiwyg).value = $event : wysiwyg = $event)),
      init: {
        height: __props.height,
        menubar: false,
        media_dimensions: false,
        media_poster: false,
        media_alt_source: false,
        images_upload_handler: wysiwyg_image_upload_handler,
        language: 'fr_FR',
        plugins: [
          'advlist autolink lists link image charmap print preview anchor image media',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
        ],
        file_picker_types: 'image',
        toolbar:
          'undo redo | formatselect | bold italic backcolor image media | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help',
      }
    }, null, 8, ["api-key", "initialValue", "modelValue", "init"]),
    _createVNode(_component_FormKit, {
      type: "hidden",
      name: "images",
      modelValue: images.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((images).value = $event))
    }, null, 8, ["modelValue"])
  ], 2))
}
}

})